import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import List from '../../shared/styledComponents/List';

export default InjectedStyledComponent(List, 'disclaimer', ['list']);